import type { PdpProduct } from 'components/discovery/pdp/typing/pdp-product.js'

export const orderTemplateQuantity = (quantity: number, productId: number, pdpProduct: PdpProduct | null): number => {
  if (quantity || !pdpProduct || pdpProduct.id !== productId) return quantity
  return pdpProduct.ordering.minimum_order_quantity || pdpProduct.ordering.order_quantity || 1
}
